/* eslint-disable max-len */
import { FunctionComponent } from 'react';
import Head from 'next/head';
type Props = {
  readonly path: string;
  readonly title: string;
  readonly description: string;
  readonly shareImage?: string;
  readonly preventIndexing?: boolean;
};
const PageHead: FunctionComponent<Props> = ({
  path,
  title,
  description,
  shareImage,
  preventIndexing = false
}) => {
  // set env vars. to set url, other derived vars
  const production: boolean = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';
  const preview: boolean = process.env.NEXT_PUBLIC_PREVIEW === 'true';
  const siteStage: boolean = production && preview;
  let siteUrl = preview ? 'http://localhost:3000' : 'https://tewps.com';
  if (siteStage) {
    siteUrl = 'https://staging.tewps.com/';
  }
  return <Head data-sentry-element="Head" data-sentry-component="PageHead" data-sentry-source-file="Head.tsx">
			<title>{title}</title>

			<meta name="description" content={description} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<link rel="icon" href="/tort-favicon.png" sizes="32x32" />

			<link rel="apple-touch-icon" href="/apple-touch-icon.png" />

			{/* Twitter Card */}

			<meta name="twitter:card" content={shareImage} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta name="twitter:title" content={title} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta name="twitter:description" content={description} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta name="twitter:image" content={shareImage} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="twitter:player:width" content="724" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />
			<meta property="twitter:player:height" content="373" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta name="twitter:url" content={`${siteUrl}${path}`} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			{/* Open Graph */}

			<meta property="og:type" content="website" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:title" content={`${title}`} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:site_name" content={title} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:description" content={`${description}`} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:image" content={shareImage} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:image:secure_url" content={shareImage} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:image:type" content="image/webp" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:image:width" content="724" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:image:height" content="373" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta property="og:url" content={`${siteUrl}${path}`} data-sentry-element="meta" data-sentry-source-file="Head.tsx" />

			<meta name="format-detection" content="email=no,telephone=no" data-sentry-element="meta" data-sentry-source-file="Head.tsx" />
			<meta name="viewport" content="width=device-width, initial-scale=1" data-sentry-element="meta" data-sentry-source-file="Head.tsx"></meta>

			{preventIndexing && <>
					<meta name="robots" content="noindex, nofollow" />
					<meta name="googlebot" content="noindex, nofollow" />
				</>}
		</Head>;
};
export default PageHead;